import { z } from 'zod';
import { AuditSchema } from './entities/audit.schema';

export const CommentReplySchema = z.object({
  id: z.string(),
  authorId: z.string(),
  authorName: z.string(),
  content: z.string().min(1, 'Reply content cannot be empty'),
  audit: AuditSchema,
});

export type CommentReply = z.infer<typeof CommentReplySchema>;

/**
 * Schema for a comment on a text selection.
 */
export const CommentSchema = z.object({
  id: z.string(),
  authorId: z.string(),
  authorName: z.string(),
  content: z.string().min(1, 'Comment content cannot be empty'),
  status: z.enum(['open', 'resolved']).default('open'),
  replies: z.array(CommentReplySchema).optional().default([]),
  audit: AuditSchema,
});

export type Comment = z.infer<typeof CommentSchema>;
